export const buildOnboardingVideoUrl = (host: string, path: string) => {
  const normalizedHost = host.endsWith('/') ? host : `${host}/`;
  const normalizedPath = path.replace(/^\//, '');
  const encodedPath = normalizedPath
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/');
  return `${normalizedHost}${encodedPath}`;
};
